/**
 * @generated SignedSource<<3338c154c4c0533c59e6142554e29337>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StorefrontSocial_seller$data = {
  readonly trackedPhone: {
    readonly phoneNumber: string | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"StorefrontCallButton_seller" | "StorefrontSocialShare_seller">;
  readonly " $fragmentType": "StorefrontSocial_seller";
};
export type StorefrontSocial_seller$key = {
  readonly " $data"?: StorefrontSocial_seller$data;
  readonly " $fragmentSpreads": FragmentRefs<"StorefrontSocial_seller">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StorefrontSocial_seller",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "StorefrontCallButton_seller"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "StorefrontSocialShare_seller"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Phone",
      "kind": "LinkedField",
      "name": "trackedPhone",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "phoneNumber",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Seller",
  "abstractKey": null
};

(node as any).hash = "60911678ad8e7e92f9c01d4039fafa37";

export default node;
